const UrCarConst = {
    SELLERID: 'SELLERID',
    SELLERDATA: 'SELLERDATA',
    ERROR: 'ERROR'
};

const UrCarAction = {
    sellerid,
    sellerData,
    error
};


function sellerid(payload) {
    return { type: UrCarConst.SELLERID, payload };
}

function sellerData(payload) {
    return { type: UrCarConst.SELLERDATA, payload };
}

function error(payload) {
    return { type: UrCarConst.ERROR, payload };
}

export default UrCarAction;